module.exports = __webpack_public_path__ + "img/25.6b7c773c.jpg";